<template>
  <div>
    <v-card-text>
      <v-alert v-if="errors.length" type="error" class="rounded-lg" dismissible @input="closeAlert">
        <div v-for="(error, index) in errors" :key="index" v-html="error"></div>
      </v-alert>
      <v-alert v-if="successes.length" type="success" class="rounded-lg " dismissible @input="closeAlert">
        <div v-for="(success, index) in successes" :key="index" v-html="success"></div>
      </v-alert>
      <v-form ref="form" :readonly="!editMode">
        <!-- First Row -->
        <v-row>
          <v-col>
            <v-text-field
              v-model="formCollaborator.firstname"
              v-bind="collaboratorFieldsProperties('firstname')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="formCollaborator.lastname"
              v-bind="collaboratorFieldsProperties('lastname')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="formCollaborator.mobilephone"
              v-bind="collaboratorFieldsProperties('mobilephone')"
              :error="phoneOrEmailRequired"
            />
          </v-col>
        </v-row>
        <!-- Second Row -->
        <v-row>
          <v-col>
            <v-text-field
              v-model="formCollaborator.personalEmail"
              v-bind="collaboratorFieldsProperties('personalEmail')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="formCollaborator.email"
              v-bind="collaboratorFieldsProperties('email')"
              :error="phoneOrEmailRequired"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="formCollaborator.broadBeanUsername"
              v-bind="collaboratorFieldsProperties('broadBeanUsername')"
            />
          </v-col>
        </v-row>
        <!-- Third Row -->
        <v-row>
          <v-col>
            <v-text-field
              v-model="formCollaborator.employeeNumber"
              v-bind="collaboratorFieldsProperties('employeeNumber')"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="formCollaborator.registrationNumber"
              v-bind="collaboratorFieldsProperties('registrationNumber')"
            />
          </v-col>
          <v-col class="d-flex justify-center">
            <div>
              <v-row dense class="d-flex justify-center">
                <v-switch
                  v-model="useSSO"
                  v-bind="collaboratorFieldsProperties('useSSO')"
                  :class="formCollaborator.sso_id ? 'mt-n2' : ''"
                  dense
                  :readonly="formCollaborator.sso_id !== null || !editMode"
                />
              </v-row>
              <v-row v-if="formCollaborator.sso_id">
                <v-btn :disabled="editMode" color="warning" small @click="showDialog()">{{ getLabel("reset_password") }}</v-btn>
              </v-row>
            </div>
          </v-col>
          <v-dialog
            v-model="dialog"
            min-width="400"
            max-width="450"
          >
            <v-card>
              <v-sheet color="grey">
                <v-card-title class="text-h5 pa-2">
                  <v-col class="">
                    <span class="white--text text-center">
                      {{ getLabel("reset_password") }}
                    </span>
                  </v-col>
                </v-card-title>
              </v-sheet>
              <v-card-text class="text-body-1 py-4">
                {{ getLabel("reset_password_question") }}
              </v-card-text>
              <v-divider />
              <v-card-actions class="pt-4">
                <v-spacer />
                <v-btn
                  class="mb-2"
                  color="red darken-1"
                  dark
                  large
                  @click="dialog = false"
                >
                  <v-icon class="mr-2">mdi-close-thick</v-icon>
                  {{ getLabel("no") }}
                </v-btn>
                <v-btn
                  class="mb-2 ml-2"

                  color="green darken-1"
                  large
                  dark
                  @click="resetPassword()"
                >
                  <v-icon class="mr-2">mdi-check-bold</v-icon>

                  {{ getLabel("yes") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Fourth Row -->
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="formCollaborator.street_number"
              v-bind="collaboratorFieldsProperties('street_number')"
            />
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model="formCollaborator.street_name"
              v-bind="collaboratorFieldsProperties('street_name')"
            />
          </v-col>
        </v-row>
        <!-- Fifth Row -->
        <v-row>
          <v-col>
            <v-text-field
              v-model="formCollaborator.address1"
              v-bind="collaboratorFieldsProperties('address1')"
            />
          </v-col>
        </v-row>
        <!-- Sixth Row -->
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="formCollaborator.town"
              v-bind="collaboratorFieldsProperties('town')"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="formCollaborator.zip_code"
              v-bind="collaboratorFieldsProperties('zip_code')"
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="formCollaborator.country"
              v-bind="collaboratorFieldsProperties('country')"
              :items="countries"
              :clearable="editMode"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="formCollaborator.qrCode"
              v-bind="collaboratorFieldsProperties('qrCode')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-combobox
              v-model="formCollaborator.extraBuildingCodes"
              v-bind="collaboratorFieldsProperties('extraBuildingCodes')"
              chips
              small-chips
              multiple
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider />
    <v-card-text class="d-flex " :class="(isCallCenterRequest.isActive || isHelloRequest.isActive) ? 'justify-space-between' : 'justify-end'">
      <div v-if="isCallCenterRequest.isActive" class="d-flex align-self-start">
        <v-btn color="orange" dark x-large @click="sendCollaboratorToSearch()">
          <v-icon class="mr-1">mdi-plus</v-icon> {{ getLabel("add_collab_to_search") }}
        </v-btn>
      </div>
      <div v-if="isHelloRequest.isActive" class="d-flex align-self-start">
        <v-btn color="orange" dark x-large @click="sendCollaboratorToHello()">
          <v-icon class="mr-1">mdi-plus</v-icon> {{ getLabel("add_collab_to_hello") }}
        </v-btn>
      </div>
      <div>
        <div v-if="editMode">
          <v-btn x-large color="warning" class="ml-4" @click="cancelEdit()">
            <v-icon class="mr-3">mdi-broom</v-icon>
            {{ getLabel("cancel") }}
          </v-btn>
          <v-btn x-large color="success" class="ml-4" @click="saveCollaborator()">
            <v-icon class="mr-3">mdi-content-save</v-icon>
            {{ getLabel("save") }}
          </v-btn>
        </div>
        <div v-else>
          <v-btn class="mr-4" x-large dark color="primary" @click="showDeleteCollaboratorDialog()">
            <v-icon class="mr-3">mdi-delete</v-icon>
            {{ getLabel("delete") }}
          </v-btn>
          <v-btn color="grey" dark x-large @click="startEdit()">
            <v-icon class="mr-1">mdi-pencil</v-icon> {{ getLabel("edit") }}
          </v-btn>
        </div>
      </div>
    </v-card-text>
    <v-divider />
    <!-- Groups Collaborator -->
    <v-card class="rounded-lg ma-4">
      <v-sheet color="primary">
        <v-card-title class="pa-2">
          <div class="text-body-1 ml-2 white--text">
            {{ getLabel("groups") }}
          </div>
        </v-card-title>
      </v-sheet>
      <v-card-text>
        <div v-if="groupsToShow.length === 0" class="text-center text-body-1">{{ getLabel("no_groups") }}</div>
        <v-chip
          v-for="group in groupsToShow"
          :key="group.uuid"
          class="ma-2"
          close
          @click:close="removeFromGroup(group.uuid)"
        >
          {{ group.name }}
        </v-chip>
        <div class="pt-4 text-center">
          <v-btn color="primary" large @click="addGroup()"><v-icon>mdi-plus</v-icon>{{ getLabel("add_group") }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <!-- dialog box from DELETE -->
    <v-dialog
      v-model="deleteCollaboratorDialog"
      min-width="400"
      max-width="450"
    >
      <v-card>
        <v-sheet color="red">
          <v-card-title class="text-h5">
            <v-row>
              <v-col cols="2" class="d-flex justify-center">
                <v-icon
                  x-large
                  color="white"
                >
                  mdi-alert-outline
                </v-icon>
              </v-col>
              <v-col class="pl-0">
                <span class="white--text text-center">
                  {{ getLabel("delete_collaborator_question") }}
                </span>
              </v-col>
            </v-row>
          </v-card-title>
        </v-sheet>

        <v-card-text class="mt-4">
          <p class="ma-0">
            {{ getLabel("name") + ": " }}
            {{ formCollaborator.firstname === null ? '' : formCollaborator.firstname }}
            {{ " " + formCollaborator.lastname }}
          </p>
          <p v-if="formCollaborator.email" class="ma-0">
            {{ getLabel("email") + ": " + formCollaborator.email }}
          </p>
          <p v-if="formCollaborator.mobilephone" class="ma-0">
            {{ getLabel("phone") + ": " + formCollaborator.mobilephone }}
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions class="mt-2">
          <v-spacer />
          <v-btn
            class="mb-2"
            color="red darken-1"
            dark
            large
            @click="deleteCollaboratorDialog = false"
          >
            <v-icon class="mr-2">mdi-close-thick</v-icon>
            {{ getLabel("no") }}
          </v-btn>
          <v-btn
            class="mb-2 ml-2"

            color="green darken-1"
            large
            dark
            @click="deleteCollaborator()"
          >
            <v-icon class="mr-2">mdi-check-bold</v-icon>
            {{ getLabel("yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ref, computed, onActivated } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import { useRouter } from 'vue2-helpers/vue-router';

import { useMainStore } from '../../store/index';
import { countries } from '@/utils/countries';
import { getGraphqlSchema } from '../../graphql/index';
import { collaboratorFieldsProperties } from '@/utils/forms';
import { EventBus, getLabel } from '@/utils/index';

export default {
  setup (props, context) {
    const store = useMainStore();

    const router = useRouter();

    const errors = ref([]);

    const successes = ref([]);

    const closeAlert = () => {
      errors.value = [];
      successes.value = [];
    };

    const isCallCenterRequest = computed(() => store.getCallCenterData);
    const isHelloRequest = computed(() => store.getHelloData);

    const dialog = ref(false);

    const deleteCollaboratorDialog = ref(false);

    const showDialog = () => {
      dialog.value = true;
    };

    const showDeleteCollaboratorDialog = () => {
      deleteCollaboratorDialog.value = true;
    };

    const editMode = ref(false);

    const startEdit = () => {
      editMode.value = true;
    };

    const formCollaborator = ref({ ...store.collaborator });

    const groupsToShow = computed(() => store.collaborator.groups);

    const useSSO = ref(!!formCollaborator.value.sso_id);

    // Update collaborator
    const { mutate: mutationUpdateCollaborator, error: updateMutationMessageError, onDone: onDoneUpdate, onError: onErrorUpdate } = useMutation(getGraphqlSchema('updateCollaborator'), () => ({
      variables: {
        uuid: formCollaborator.value.uuid,
        firstname: formCollaborator.value.firstname.trim(),
        lastname: formCollaborator.value.lastname.trim(),
        mobilephone: formCollaborator.value.mobilephone,
        personalEmail: formCollaborator.value.personalEmail,
        email: formCollaborator.value.email,
        broadBeanUsername: formCollaborator.value.broadBeanUsername,
        employeeNumber: formCollaborator.value.employeeNumber,
        registrationNumber: formCollaborator.value.registrationNumber,
        useSSO: useSSO.value,
        street_number: formCollaborator.value.street_number,
        street_name: formCollaborator.value.street_name,
        town: formCollaborator.value.town,
        address1: formCollaborator.value.address1,
        zip_code: formCollaborator.value.zip_code,
        country: formCollaborator.value.country,
        qrCode: formCollaborator.value.qrCode,
        extraBuildingCodes: formCollaborator.value.extraBuildingCodes
      }
    }));

    onErrorUpdate(() => {
      store.loading = false;
      // when the createCollaborator mutation returns an error
      // Error cases
      let error = '';

      switch (updateMutationMessageError.value.message) {
        case 'Collaborator already exists with that email, mobilephone or employee number':
          // eslint-disable-next-line no-case-declarations
          const valuesToSearch = [formCollaborator.value.mobilephone, formCollaborator.value.employeeNumber, formCollaborator.value.email].filter(value => value);

          error = `<a class="white--text" href="/search/${encodeURIComponent(valuesToSearch.join(' '))}"> ${getLabel(updateMutationMessageError.value.message)}, cliquez ici pour la retrouver</a>`;
          break;
        default:
          error = getLabel(updateMutationMessageError.value.message);
      }

      errors.value = [error];
      successes.value = [];
    });

    onDoneUpdate(result => {
      store.loading = false;
      // when the creatorCollaborator mutation finishes
      editMode.value = false;

      // change only the attributes that have been saved
      store.collaborator = { ...store.collaborator, ...result.data.updateCollaborator };

      EventBus.$emit('update-collaborator', store.collaborator);

      errors.value = [];
      successes.value = [getLabel('collaborator_saved')];
    });

    // reset password
    const { mutate: mutationResetPassword, error: resetPasswordMutationMessageError, onDone: onDoneResetPassword, onError: onErrorResetPassword } = useMutation(getGraphqlSchema('resetPassword'), () => ({ variables: { uuid: formCollaborator.value.uuid } }));

    onErrorResetPassword(() => {
      store.loading = false;
      // when the createCollaborator mutation returns an error
      errors.value = [resetPasswordMutationMessageError.value.message];
      successes.value = [];
    });

    onDoneResetPassword(result => {
      store.loading = false;

      if (!result.data.collaboratorResetPassword) {
        errors.value = [getLabel('error_occured')];
        successes.value = [];
        return;
      }

      errors.value = [];
      successes.value = [getLabel('reset_password_request_sent')];
    });

    const resetPassword = () => {
      dialog.value = false;

      store.loading = true;

      mutationResetPassword();
    };

    const phoneOrEmailRequired = computed(() => !formCollaborator.value.mobilephone && !formCollaborator.value.email);

    const validation = () => {
      const formValidation = context.refs.form.validate();

      if (!formValidation) {
        successes.value = [];
        errors.value = [getLabel('check_fields')];

        return false;
      }

      if (phoneOrEmailRequired.value) {
        successes.value = [];
        errors.value = [getLabel('phone_or_email_required_error')];
      }

      return !phoneOrEmailRequired.value && formValidation;
    };

    const saveCollaborator = () => {
      if (validation()) {
        store.loading = true;
        mutationUpdateCollaborator();
      }
    };

    const cancelEdit = () => {
      editMode.value = false;
      useSSO.value = !!formCollaborator.value.sso_id;
      formCollaborator.value = { ...store.collaborator };
    };

    // Mutation to DELETE Collaborator
    const { mutate: mutationDeleteCollaborator, onDone: onDoneDelete, onError: onErrorDelete } = useMutation(getGraphqlSchema('deleteCollaborator'), () => ({ variables: { uuid: formCollaborator.value.uuid } }));

    onErrorDelete(error => {
      store.loading = false;

      // when the deleteCollaborator mutation returns an error

      EventBus.$emit('show-notifications', [{
        message: error.message,
        type: 'error'
      }]);
    });

    onDoneDelete(result => {
      store.loading = false;
      if (result.data.collaborator_delete_collaborator === true) {
        EventBus.$emit('collaborator-delete', store.collaborator.uuid);

        // clean store collaborator
        store.collaborator = null;

        EventBus.$emit('show-notifications', [{
          message: getLabel('collaborator_deleted'),
          type: 'success'
        }]);

        router.push({ name: 'dashboard' });
      }
    });

    const deleteCollaborator = () => {
      deleteCollaboratorDialog.value = false;
      store.loading = true;

      mutationDeleteCollaborator();
    };

    // Mutation to remove from group
    let groupToRemove = null;

    const { mutate: mutationRemoveCollaboratorFromGroup, onDone: onDoneRemove, onError: onErrorRemove } = useMutation(getGraphqlSchema('removeCollaboratorFromGroup'), () => ({
      variables: {
        uuid: groupToRemove,
        collaborator: store.collaborator.uuid
      }
    }));

    onErrorRemove(() => {
      store.loading = false;

      EventBus.$emit('show-notifications', [{
        message: getLabel('collaborator_remove_group_error'),
        type: 'danger'
      }]);
    });

    onDoneRemove(r => {
      store.loading = false;

      if (r.data.collaborator_remove_collaborator_from_group.success) {
        let temp = store.collaborator.groups;
        temp = temp.filter(g => g.uuid !== groupToRemove);
        store.collaborator.groups = temp;

        EventBus.$emit('show-notifications', [{
          message: getLabel('collaborator_removed_group'),
          type: 'success'
        }]);
        return;
      }

      EventBus.$emit('show-notifications', [{
        message: getLabel('collaborator_add_group_error'),
        type: 'danger'
      }]);
    });

    /** ********************************** */

    const removeFromGroup = uuid => {
      groupToRemove = uuid;
      store.loading = true;

      mutationRemoveCollaboratorFromGroup();
    };

    const addGroup = () => {
      store.addGroupMode = true;
      router.push({ name: 'groupsDashboard' });
    };

    onActivated(() => {
      // change "addCollaboratorMode" here to avoid one aditional request of collaborators
      store.cleanSearch();

      store.addGroupMode = false;
    });

    function sendCollaboratorToSearch () {
      const { returnUrl, orderDate, marque, iresaCode } = isCallCenterRequest.value;

      const url = `${returnUrl}/?uuid=${encodeURI(formCollaborator.value.uuid)}
&firstname=${formCollaborator.value.firstname}&lastname=${formCollaborator.value.lastname}
&date=${orderDate}&marque=${marque}&context_action=setguide&iresaCode=${iresaCode}`;
      window.location.href = url;
    }

    function sendCollaboratorToHello () {
      const { returnUrl, helloGroup } = isHelloRequest.value;

      const url = `${returnUrl}/groupe/${encodeURI(helloGroup)}?collaborateur=${encodeURI(formCollaborator.value.uuid)}`;
      window.location.href = url;
    }

    const updateExtraBuildingCodes = extraBuildingCodes => {
      // Ensure the value is always an array
      if (!Array.isArray(extraBuildingCodes)) {
        extraBuildingCodes = extraBuildingCodes ? [extraBuildingCodes] : [];
      }
    };

    return {
      isCallCenterRequest,
      isHelloRequest,
      sendCollaboratorToSearch,
      sendCollaboratorToHello,
      getLabel,
      errors,
      successes,
      closeAlert,
      dialog,
      deleteCollaboratorDialog,
      showDialog,
      showDeleteCollaboratorDialog,
      collaboratorFieldsProperties,
      countries,
      editMode,
      startEdit,
      formCollaborator,
      groupsToShow,
      useSSO,
      resetPassword,
      phoneOrEmailRequired,
      saveCollaborator,
      cancelEdit,
      deleteCollaborator,
      removeFromGroup,
      addGroup,
      updateExtraBuildingCodes
    };
  }
};
</script>
